<template src="./BlacklistUpsetDialog.html"></template>

<script lang="ts">
import BlacklistEditor from "@/components/BlacklistEditor";
import { blacklistModule } from "@/store/modules/blacklist";
import { BlacklistActions } from "@/store/modules/blacklist/actions";
import { Blacklist } from "@/models/blacklist/Blacklist";
import { BlacklistGetters } from "@/store/modules/blacklist/getters";
import { BlacklistMutation } from "@/store/modules/blacklist/mutations";
import { defineComponent } from "vue";
import { ref } from "vue";
import { VForm } from "vuetify/lib/components/VForm/VForm";

export default defineComponent({
    components: { BlacklistEditor },
    props: {
        visible: { type: Boolean, required: true },
        blacklistEntryId: { type: Number, required: false, default: 0 }
    },
    emits: ["update:visible", "cancel"],
    data() {
        return {
            currentBlacklistModel: {
                blacklistId: 0,
                email: "",
                firstName: null,
                lastName: null,
                createdDateTime: "",
                lastModifiedDateTime: ""
            } as Blacklist
        };
    },
    setup() {
        const form = ref<VForm>();
        return { form };
    },
    computed: {
        ...blacklistModule.mapGetters({
            errors: BlacklistGetters.Errors,
            loading: BlacklistGetters.IsLoading,
            blacklistModel: BlacklistGetters.Blacklist
        }),
        isVisible: {
            get() {
                return this.visible;
            },
            set(value: boolean) {
                this.$emit("update:visible", value);
            }
        }
    },
    methods: {
        ...blacklistModule.mapActions({
            createBlacklist: BlacklistActions.CreateBlacklist,
            getBlacklistById: BlacklistActions.LoadBlacklistById,
            updateBlacklist: BlacklistActions.UpdateBlacklist
        }),
        ...blacklistModule.mapMutations({
            setBlacklist: BlacklistMutation.SetBlacklist
        }),
        async submit(): Promise<void> {
            const validationResult = await this.form?.validate();
            if (!validationResult?.valid) return;

            if (this.blacklistEntryId === 0) {
                this.createBlacklist(this.currentBlacklistModel).then(
                    () => (this.isVisible = false)
                );
            } else {
                this.updateBlacklist(this.currentBlacklistModel).then(() => {
                    this.isVisible = false;
                    this.setBlacklist(this.currentBlacklistModel);
                });
            }
        },
        cancel(): void {
            this.isVisible = false;
            this.$emit("cancel");
        }
    },
    watch: {
        blacklistEntryId: {
            handler(newId: number) {
                if (newId !== 0) this.getBlacklistById(newId);
                else this.setBlacklist(null);
            },
            immediate: true
        },
        blacklistModel: {
            handler(newModel: Blacklist | null) {
                this.currentBlacklistModel =
                    newModel !== null
                        ? { ...newModel }
                        : {
                              blacklistId: 0,
                              email: "",
                              firstName: null,
                              lastName: null,
                              createdDateTime: "",
                              lastModifiedDateTime: ""
                          };
            },
            deep: true
        }
    }
});
</script>
